import i18n from '../../i18n';

/**
 * Columns on list_regime_mapping that override account-level interrupt_assignment.
 * Must match bigdayz.new LIST_REGIME_INTERRUPT_COLUMN_TO_NAME and DB schema.
 */
export const FOLDER_INTERRUPT_OVERRIDE_FIELDS = [
  {
    key: 'is_fan_asks_for_content_enabled',
    interruptName: 'fan_asks_for_content',
    label: i18n.t('chatAssistant:interrupts.fanAsksForContent'),
  },
  {
    key: 'is_fan_asks_about_catalog_enabled',
    interruptName: 'fan_asks_about_catalog',
    label: i18n.t('chatAssistant:interrupts.fanAsksAboutCatalog'),
  },
  {
    key: 'is_fan_wants_to_buy_content_enabled',
    interruptName: 'fan_wants_to_buy_content',
    label: i18n.t('chatAssistant:interrupts.fanWantsToBuyContent'),
  },
  {
    key: 'is_fan_awaiting_media_enabled',
    interruptName: 'fan_awaiting_media',
    label: i18n.t('chatAssistant:interrupts.fanAwaitingMedia'),
  },
  {
    key: 'is_fan_asks_for_custom_content_enabled',
    interruptName: 'fan_asks_for_custom_content',
    label: i18n.t('chatAssistant:interrupts.fanAsksForCustomContent'),
  },
  {
    key: 'is_fan_asks_for_voice_video_call_enabled',
    interruptName: 'fan_asks_for_voice_video_call',
    label: i18n.t('chatAssistant:interrupts.fanAsksForVoiceVideoCall'),
  },
  {
    key: 'is_fan_asks_how_model_looks_now_enabled',
    interruptName: 'fan_asks_how_model_looks_now',
    label: i18n.t('chatAssistant:interrupts.fanAsksHowModelLooksNow'),
  },
  {
    key: 'is_fan_asks_for_verification_photo_enabled',
    interruptName: 'fan_asks_for_verification_photo',
    label: i18n.t('chatAssistant:interrupts.fanAsksForVerificationPhoto'),
  },
  {
    key: 'is_fan_asks_to_see_body_part_enabled',
    interruptName: 'fan_asks_to_see_body_part',
    label: i18n.t('chatAssistant:interrupts.fanAsksToSeeBodyPart'),
  },
  {
    key: 'is_fan_not_happy_enabled',
    interruptName: 'fan_not_happy',
    label: i18n.t('chatAssistant:interrupts.fanNotHappy'),
  },
  {
    key: 'is_fan_suspects_ai_or_fake_enabled',
    interruptName: 'fan_suspects_ai_or_fake',
    label: i18n.t('chatAssistant:interrupts.fanSuspectsAiOrFake'),
  },
  {
    key: 'is_fan_no_money_enabled',
    interruptName: 'fan_no_money',
    label: i18n.t('chatAssistant:interrupts.fanNoMoney'),
  },
  {
    key: 'is_fan_asks_about_pricing_enabled',
    interruptName: 'fan_asks_about_pricing',
    label: i18n.t('chatAssistant:interrupts.fanAsksAboutPricing'),
  },
  {
    key: 'is_fan_asks_off_platform_or_external_payment_enabled',
    interruptName: 'fan_asks_off_platform_or_external_payment',
    label: i18n.t('chatAssistant:interrupts.fanAsksOffPlatformOrExternalPayment'),
  },
  {
    key: 'is_fan_offers_external_payment_enabled',
    interruptName: 'fan_offers_external_payment',
    label: i18n.t('chatAssistant:interrupts.fanOffersExternalPayment'),
  },
  {
    key: 'is_fan_mentions_banned_platform_topic_enabled',
    interruptName: 'fan_mentions_banned_platform_topic',
    label: i18n.t('chatAssistant:interrupts.fanMentionsBannedPlatformTopic'),
  },
  {
    key: 'is_fan_mentions_other_model_page_enabled',
    interruptName: 'fan_mentions_other_model_page',
    label: i18n.t('chatAssistant:interrupts.fanMentionsOtherModelPage'),
  },
  {
    key: 'is_fan_stopped_responding_enabled',
    interruptName: 'fan_stopped_responding',
    label: i18n.t('chatAssistant:interrupts.fanStoppedResponding'),
  },
] as const;

export type FolderInterruptFieldKey = (typeof FOLDER_INTERRUPT_OVERRIDE_FIELDS)[number]['key'];

/** Folder row from API — subset of FolderAiSetup for interrupt columns. */
export type FolderAiSetupLike = {
  [K in FolderInterruptFieldKey]?: boolean | null;
};

export function allInterruptsYesRecord(): Record<FolderInterruptFieldKey, boolean> {
  const o = {} as Record<FolderInterruptFieldKey, boolean>;
  for (const { key } of FOLDER_INTERRUPT_OVERRIDE_FIELDS) {
    o[key] = true;
  }
  return o;
}

/** Per-interrupt Yes/No from a saved row; missing/null columns count as Yes (on). */
export function interruptValuesFromRow(row: FolderAiSetupLike): Record<FolderInterruptFieldKey, boolean> {
  const out = {} as Record<FolderInterruptFieldKey, boolean>;
  for (const { key } of FOLDER_INTERRUPT_OVERRIDE_FIELDS) {
    const v = row[key];
    out[key] = v !== false;
  }
  return out;
}
